import { render, staticRenderFns } from "./coupon-details.vue?vue&type=template&id=35708552&"
import script from "./coupon-details.vue?vue&type=script&lang=js&"
export * from "./coupon-details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports